import { compose } from 'recompose';
import apiInterceptor from '../../../api/interceptor';
import { srnVatApi } from '../../common/base.api';
import SRNVatReport from './SRNVatReport';

const composedSRNVatReport = compose(apiInterceptor({ ...srnVatApi }))(SRNVatReport);

export default composedSRNVatReport;
